/**
 * @deprecated
 */
export const HOME_PAGE_AB_VERSION = 'dotcom_home_page_ab';
/**
 * @deprecated
 */
export const STORE_HERO_DEFAULT_OPTION = 'dotcom_store_hero_option';
/**
 * @deprecated
 */
export const STORE_HERO_DEFAULT_OPTION_2 = 'dotcom_store_hero_option_2';
export const EU_GL_BUNDLE_STORE = 'dotcom_eu_gl_bundle_store';

export const JULY_2025_EXP = 'dotcom_store_exp_july_2025';
